import { render, staticRenderFns } from "./TextOrNA.vue?vue&type=template&id=0628f784&"
import script from "./TextOrNA.vue?vue&type=script&lang=ts&"
export * from "./TextOrNA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports